module.exports = __webpack_public_path__ + "assets/img/activity-time-bf8d75cd.png";